import { render, staticRenderFns } from "./SearchEnginePodcasts.vue?vue&type=template&id=2b7b8f37&scoped=true&"
import script from "./SearchEnginePodcasts.vue?vue&type=script&lang=js&"
export * from "./SearchEnginePodcasts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b8f37",
  null
  
)

export default component.exports